import { useFormContext } from 'react-hook-form';
import type { OnboardingFormValues } from '../schema';

export function ProfileStep() {
  const form = useFormContext<OnboardingFormValues>();
  const errors = form.formState.errors;

  return (
    <div className="space-y-6">
      <Field
        label="Full name"
        required
        hint="Appears on your hero and in metadata."
        error={errors.name?.message}
      >
        <input
          {...form.register('name')}
          placeholder="Ada Lovelace"
          autoFocus
          className="w-full rounded-lg border border-line bg-board px-4 py-3 text-[15px] text-ink placeholder:text-ink-faint focus:border-ink focus:outline-none"
        />
      </Field>

      <Field
        label="Headline"
        hint="One line that describes what you do."
        error={errors.headline?.message}
      >
        <input
          {...form.register('headline')}
          placeholder="Independent designer working on tools for thought"
          className="w-full rounded-lg border border-line bg-board px-4 py-3 text-[15px] text-ink placeholder:text-ink-faint focus:border-ink focus:outline-none"
        />
      </Field>

      <Field
        label="Location"
        hint="Optional. Shown on your contact section."
        error={errors.location?.message}
      >
        <input
          {...form.register('location')}
          placeholder="Berlin, DE"
          className="w-full rounded-lg border border-line bg-board px-4 py-3 text-[15px] text-ink placeholder:text-ink-faint focus:border-ink focus:outline-none"
        />
      </Field>
    </div>
  );
}

function Field({
  label,
  hint,
  required,
  error,
  children,
}: {
  label: string;
  hint?: string;
  required?: boolean;
  error?: string;
  children: React.ReactNode;
}) {
  return (
    <label className="block">
      <span className="mb-2 flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.18em] text-ink-faint">
        {label}
        {required ? <span className="text-ink">*</span> : null}
      </span>
      {children}
      {error ? (
        <span className="mt-1.5 block text-xs text-red-600">{error}</span>
      ) : hint ? (
        <span className="mt-1.5 block text-xs text-ink-muted">{hint}</span>
      ) : null}
    </label>
  );
}
